<div id="globalSearch" class="containerMargins">
  <app-filterable-table
    [tableView]="tableView"
    [options]="searchTableOptions"
    (selectedRecord)="handleRecordSelected($event)"
  ></app-filterable-table>

  <div
    [hidden]="!viewingDetails"
    style="padding: 10px; border: 1px solid #dddddd; border-radius: 5px"
  >
    @if (selectedMerchant != undefined) {
      <div>
        <app-merchant-details
          [merchant]="selectedMerchant"
        ></app-merchant-details>
      </div>
    }
    @if (selectedTransaction != undefined) {
      <div>
        <app-transaction-details
          [transaction]="selectedTransaction"
        ></app-transaction-details>
      </div>
    }
    @if (selectedCustomer != undefined) {
      <div>
        <app-customer-details
          [customer]="selectedCustomer"
        ></app-customer-details>
      </div>
    }
    @if (selectedAccount != undefined) {
      <div>
        <app-account-details-form
          [account]="selectedAccount"
        ></app-account-details-form>
      </div>
    }
    <input type="button" value="Close" (click)="btnCloseDetails_click()" />
  </div>
</div>
